import React from 'react'
// components
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
// icons
import { ClearIcon } from '@mui/x-date-pickers'

const ClearButton: React.FC<{ onChange: () => void }> = ({ onChange }) => {
  return (
    <>
      <InputAdornment position='end'>
        <IconButton size='small' onClick={onChange}>
          <ClearIcon fontSize='small' />
        </IconButton>
      </InputAdornment>
    </>
  )
}

export default ClearButton
